
import { fns, libTypes } from "@holta/lib";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import {create} from 'mutative';

export const setDoorsReceived = (doorsReceived: libTypes.Order['doorsReceived']) => {

    const editOrder = getEditOrder();

    useStore.setState({
        editOrder : create(editOrder, draft => {
            draft.newValues.order.doorsReceived = fns.order.set.doorsReceived(doorsReceived);
        })
    });
};
